import { css } from '@emotion/react';
import { COLOR_PALETTE } from '@inflearn/ds-react-next';
import { convertObjectToCSSString } from '@inflearn/pdf';
import { i18n } from 'next-i18next';

import { PDF_SIZE_PORTRAIT } from '../../../../../constants/pdf';
import { formatDate } from '../../../../../utils/date';
import { makeSignatureStamp } from './SignatureStampTemplate';

export const CERTIFICATE_WIDTH = PDF_SIZE_PORTRAIT.A4.WIDTH;
export const CERTIFICATE_WRAPPER_ID = 'certificate-wrapper';

export function CertificateWrapper() {
  return <div id={CERTIFICATE_WRAPPER_ID} css={styleWrapper} />;
}

const styleWrapper = css({
  top: '-999px',
  maxWidth: 1024,
  position: 'fixed',
});

export type CertificationOfVoucherTemplateProps = {
  realName: string;
  voucher: {
    id: number;
    courseId: number;
    createdAt: string;
    courseTitle: string;
  };
};

export const makeCertificationOfVoucherTemplate = ({
  realName,
  voucher,
}: CertificationOfVoucherTemplateProps) => `
  <head>
    <style>
     .voucher_certification > .certificate_tmpl  {
      .certificate_tmpl__container {
        table {
          th {
            width: 145px;
            border: 1px solid ${COLOR_PALETTE.gray[3]};
          }

          td {
            width: 335px;
            padding: 8px 12px;
            border: 1px solid ${COLOR_PALETTE.gray[3]};
            text-align: left;
          }
        }
      }
      .document_meta {
        p + p {
          margin-top: 16px;
        }
      }
    }
    </style>
  </head>
  <div class="voucher_certification" style="${convertObjectToCSSString({
    position: 'relative',
    width: '700px',
    height: '540px',
    margin: 'auto',
    padding: '8px 0',
  })}">
    <div class="certificate_tmpl" style="${convertObjectToCSSString({
      position: 'relative',
      width: '640px',
      height: '480px',
      margin: 'auto',
      padding: '48px',
      border: `1px solid ${COLOR_PALETTE.gray[9]}`,
      textAlign: 'center',
    })}">
      <div class="certificate_tmpl__container" style="${convertObjectToCSSString({
        marginBottom: '24px',
      })}">
        <h1 style="${convertObjectToCSSString({
          fontSize: '36px',
          fontWeight: 500,
          marginBottom: '16px',
        })}">${i18n?.t('수강증')}</h1>
        <table style="${convertObjectToCSSString({
          width: '480px',
          margin: '0 auto',
        })}">
          <tr>
            <th>${i18n?.t('성명')}</th>
            <td>${realName}</td>
          </tr>
          <tr>
            <th>${i18n?.t('강의명')}</th>
            <td>${voucher.courseTitle}</td>
          </tr>
          <tr>
            <th>${i18n?.t('수강신청일')}</th>
            <td>${formatDate(voucher.createdAt, 'LL')}</td>
          </tr>
        </table>
      </div>
      <div class="document_meta" style="${convertObjectToCSSString({
        position: 'relative',
      })}">
        <p>${formatDate(new Date().toISOString(), 'LL')}</p>
        <p>${i18n?.t('위 수강현황은 사실과 같음을 증명합니다.')}</p>
        <p style="${convertObjectToCSSString({
          marginTop: '24px',
          fontSize: '20px',
          fontWeight: 700,
        })}">${i18n?.t('주식회사 인프랩')}</p>
        <i  style="${convertObjectToCSSString({
          position: 'absolute',
          right: '120px',
          bottom: '-35px',
          zIndex: 999,
        })}">
          ${makeSignatureStamp({
            width: '108px',
            height: '108px',
            className: 'signature-stamp',
          })}
        </i>
      </div>
      <div style="${convertObjectToCSSString({
        position: 'absolute',
        right: '8px',
        bottom: '4px',
        color: COLOR_PALETTE.gray[6],
      })}">
        <span>${voucher.id}-${voucher.courseId}</span>
      </div>
    </div>
  </div>
`;
